import { useCallback, useState } from 'react';

export const useToggle = (defaultState = false) => {
  const [isOn, setIsOn] = useState(defaultState);

  const on = useCallback(() => setIsOn(true), []);

  const off = useCallback(() => setIsOn(false), []);

  const toggle = useCallback(() => setIsOn(currentState => !currentState), []);

  return { isOn, on, off, toggle };
};
